import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">视频精选</h2>
          <p className="text-sm md:text-base text-foreground-400">精选国产热门娱乐视频内容，精彩不容错过</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden group cursor-pointer hover:border-primary-200/50 transition-all duration-300"
            >
              <div className="relative aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-xs font-bold bg-accent-500 text-background-50 rounded-md">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium bg-black/70 text-white rounded-md">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-950 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views} 次观看
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}